import { useEffect } from "react";
import EmailUsPage from "~/lib/components/views/email-us";
import { getSeoMeta } from "~/lib/utils/seo";
import { MetaFunction } from "@remix-run/react";
import { HELP_CENTER_CONSTANTS } from "~/lib/utils/const";

export const meta: MetaFunction = () => {
  return getSeoMeta({
    title: `${HELP_CENTER_CONSTANTS.label} - Email Us`,
    description: "Email us regarding any of your problems or concerns!",
    url: "https://help.setel.com/",
    image: "/images/meta-image.png",
  });
};

function PageLayout() {
  useEffect(() => {
    window.history.scrollRestoration = "manual";
  }, []);
  return <EmailUsPage />;
}

export default PageLayout;
